/**
 * Custom menu frontend compatibility for ScandiPWA
 * @copyright Scandiweb, Inc. All rights reserved.
 */

import { MenuItemComponent } from 'Component/MenuItem/MenuItem.component';
import { Mods, ReactElement } from 'Type/Common.type';

import { FormattedMenuItem } from '../type/Menu.type';

/** @namespace Scandiweb/ScandipwaMenu/Plugin/MenuItem/Plugin/renderItemWithItemClass */
export const renderItemWithItemClass = (
    [item, itemMods]: [FormattedMenuItem, Mods],
    _callback: void,
    instance: MenuItemComponent,
): ReactElement => {
    const { item_class = '', title } = item;

    return (
        <figcaption
          block="Menu"
          elem="ItemCaption"
          mods={ itemMods }
          mix={ { block: item_class } }
        >
            { title }
            { instance.renderExpandButton() }
        </figcaption>
    );
};

export default {
    'Component/MenuItem/Component': {
        'member-function': {
            renderItemContent: renderItemWithItemClass,
        },
    },
};
